import React from 'react';
import Box from '@mui/material/Box';

const Loading = () => (
  <Box sx={{ width: '100vw', height: '100vh', bgcolor: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <img src={require('../assets/loading.gif')} alt="Loading..." style={{ width: 64, height: 64 }} />
  </Box>
);

export default Loading; 